<template>
	<nav aria-label="Page navigation example">
		<ul class="pagination">
			<template v-for="(link, key) in links">
				<li v-if="link.url === null" :key="key" class="page-item disabled">
					<span class="page-link" v-html="link.label"></span>
				</li>
				<li v-else :key="key" class="page-item" :class="{'disabled selected': pagination.current_page == link.label}">
					<inertia-link class="page-link" :href="link.url" v-html="link.label"></inertia-link>					
				</li>
			</template>
		</ul>
	</nav>
</template>

<script>
	export default {
		props: {
			pagination: Object,
		},

		data() {
			return {
				links: this.pagination.links
			}
		}
	}
</script>